import { render, staticRenderFns } from "./InsuranceProductCard.vue?vue&type=template&id=084adaa5&"
import script from "./InsuranceProductCard.vue?vue&type=script&lang=js&"
export * from "./InsuranceProductCard.vue?vue&type=script&lang=js&"
import style0 from "./InsuranceProductCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusIcon: require('/~/src/modules/opus/components/Icon.vue').default,ContentfulRichText: require('/~/src/modules/contentful/components/RichText.vue').default,OpusCard: require('/~/src/modules/opus/components/Card.vue').default})
